var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"qjc-nav-bar",attrs:{"title":"404","left-arrow":"","fixed":""},on:{"click-left":function($event){return _vm.$router.back()}}}),_c('div',{staticClass:"notFound qjc-absolute qjc-fts-32"},[_c('p',[_vm._v("頁面走丟了")]),_c('router-link',{staticClass:"qjc-c-primary",attrs:{"to":"/"}},[_vm._v("點擊返回首頁")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }